export enum StockTagTypeEnum {
  ROOM_BASED,
  PERSON_BASED,
}
